import React, { useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
// import { useNavigate } from 'react-router'

export const SelectorCharacterUI = ({ callback }) => {
	// const navigator = useNavigate()
	const [btnActive, setbtnActive] = useState(false);

	ObserverEmitter.on(EVENTS.selectCharacterIntroduction, (value) => {
		setbtnActive(true);
	});
	return (
		<>
			<div className="fixed top-4 md:top-8 w-full px-4 h-9 md:h-11 animate__animated animate__fadeInDown flex justify-center">
				<div className="rounded-lg h-full px-4 py-5 md:px-7 md:py-7 bg-red_primary flex items-center justify-center">
					<p className="text-white text-sm md:text-2xl font-bold ">Selecciona a tu acompañante durante el curso</p>
				</div>
			</div>
			<div className="fixed bottom-5 md:bottom-10 w-full flex justify-center  animate__animated animate__fadeInUp">
				{btnActive && (
					<button
						onClick={() => {
							callback();
						}}
						className="boxShadowButtons bg-[#FFC427] text-white text-[20px] md:text-[24px] md:text-xl font-semibold rounded-lg w-[256px] h-[40px] md:w-[268px] md:h-[48px] md:py-2"
					>
						Continuar
					</button>
				)}
			</div>
		</>
	);
};
